<!-- =========================================================================================
    File Name: TableStriped.vue
    Description: Rendering default table with striped style
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent, Martin vicencio
    Author URL: sae.upbicentenario.edu.mx
========================================================================================== -->

<template>
    <vx-card title="Grupos(Estancias y Estandia" code-toggler>
        <div class="row">
            <div class="col-1">
                Año

                <div>
                    <v-select label="anio" @change="onChangeAnioList($event)" v-model="anioList" :options="anios">
                        
                    </v-select>
                    <!-- <vs-input class="" type="number" style="width: 100%" placeholder="" v-model="anioSelectedList" /> -->

                </div>
            </div>
            <div class="col-2">
                Periodo
                <div>
                    <!-- :$vs.notify({title:'Position top-left',text:'Es necesario seleccionar un año',color:'danger',position:'top-left'} -->
                    <v-select label="nombre" @change="onChangePeriodoList($event)" v-model="periodoList" :options="periodosList"></v-select>
                </div>
            </div>
            <div class="col-2">
                Carrera
                <div>
                    <v-select class="float-left" @change="onChangeCarreraList($event)" style="width: 100%;" label="nombre" v-model="carreraListSelected" :options="carreras"></v-select>
                </div>
            </div>
            <!-- <div class="col-1">
                Cuatrimestre
                <div>
                    <v-select class="float-left" @change="onChangeCuatrimestreList($event)" style="width: 100%;" label="cuatrimestre" v-model="cuatrimestreListSelected" :options="cuatrimestres"></v-select>
                </div>
            </div> -->
            <div class="col-2">
                Materias
                <div>
                    <v-select class="float-left" @change="onChangeMateriasList($event)" style="width: 100%;" label="nombre" v-model="materiaListSelected" :options="materias_carrera_cuatrimestre_list"></v-select>
                </div>
            </div>
            <!-- <div class="col-1">
                Grupo
                <div>
                    <v-select class="float-left" @change="onChangeDigitosList($event)"  style="width: 100%;" label="digito" v-model="digitoListSelected" :options="digitos_list"></v-select>
                </div>
            </div>
            <div class="col-3">
                Profesores de la carrera
                <div>
                    <v-select class="float-left" @change="onChangeProfesoresList($event)" style="width: 100%;" label="ncompleto" v-model="profesorListSelected" :options="carreras_profesores_list"></v-select>
                </div>
            </div> -->
            
        </div>

                <!-- Inicia listado de los alumnos de un grupo -->
                <vs-popup fullscreen  class="holamundo"  title="" :active.sync="modalAlumnos">
                    <form class="row row-cols-lg-auto g-3 align-items-center">
                        <div class="col-3">
                            <label for="inputMatricula">Matrícula</label>
                            <div class="input-group">
                                <vs-input type="number" id="inputMatricula" v-model="matriculaGrupo" />
                               <vs-button type="filled" @click.prevent="agregar_alumno_grupo()" class="ml-5">Agregar</vs-button>  <!-- lomio -->
                            </div>
                        </div>
                        <div class="col-9">
                            <span class="text-danger text-sm" v-show="error_agregar_matricula !== ''">{{ error_agregar_matricula }}</span>
                        </div>
                    </form>
                    <div class="row mt-5">
                        <div class="row">
                            <div class="card col-12">
                            <div class="card-body">
                                <h5 class="card-title">{{nombre_materia_grupo_modal}}</h5>
                                <h6 class="card-subtitle mb-2 text-muted">{{nombre_profesor_grupo_modal}}</h6>
                            </div>
                            </div>
                        </div>
                        <div class="row">
                            <vs-table stripe :data="alumnosGrupo">
                                <template slot="thead">
                                      <vs-th>Número</vs-th>
                                        <vs-th>Matrícula</vs-th>
                                        <vs-th>Nombre completo</vs-th>
                                        <!-- <vs-th>Calificación 1er. Parcial</vs-th>
                                        <vs-th>Calificación 2do. Parcial</vs-th> -->
                                        <!-- <vs-th>Calificación Final</vs-th> -->
                                        <!-- <vs-th>Calificación Ex. Regular</vs-th>
                                        <vs-th>Calificación Ex. Extraordinario</vs-th> -->
                                        <vs-th>Calificación Definitiva</vs-th>
                                        <vs-th>Calificar</vs-th>
                                        <vs-th>Baja</vs-th>
                                </template>

                      <template slot-scope="{data}">
                                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                         <vs-td :data="data[indextr].id">
                                            <!-- {{data[indextr].matricula}}-->
                                            {{ indextr + 1 }}
                                        </vs-td>
                                        <vs-td :data="data[indextr].id">
                                            {{data[indextr].matricula}}                                      
                                        </vs-td>
                                        <vs-td :data="data[indextr].id">
                                            {{data[indextr].nombre}}
                                        </vs-td>
                                        <!-- <vs-td :data="data[indextr].id">
                                            <div v-if="data[indextr].liberadaPrimerParcial==1">
                                                    {{data[indextr].calificacionPrimerParcial}} <span class="text-success text-sm">liberada</span>
                                            </div><div v-else >
                                                     {{data[indextr].calificacionPrimerParcial}}  <span class="text-danger text-sm">sin liberar</span>
                                                    </div>                                            
                                        </vs-td>
                                        <vs-td :data="data[indextr].id">
                                           <div v-if="data[indextr].liberadaSegundoParcial==1">
                                                    {{data[indextr].calificacionSegundoParcial}} <span class="text-success text-sm">liberada</span>
                                            </div><div v-else >
                                                     {{data[indextr].calificacionSegundoParcial}}  <span class="text-danger text-sm">sin liberar</span>
                                                    </div>
                                        </vs-td>
                                        <vs-td :data="data[indextr].id">
                                            {{data[indextr].calificacionFinal}}
                                        </vs-td> -->

                                        <!-- <vs-td :data="data[indextr].id">
                                          
                                   <div v-if="data[indextr].liberadaRegular==1">
                                                    {{data[indextr].calificacionRegular}} <span class="text-success text-sm">liberada</span>
                                            </div><div v-else-if="data[indextr].calificacionFinal<7" >
                                                     {{data[indextr].calificacionRegular}}  <span class="text-danger text-sm">sin liberar</span>
                                                    </div>
                                        </vs-td> -->

                                        <!-- <vs-td :data="data[indextr].id">
                                           
                                             <div v-if="data[indextr].liberadaExtraordinario==1">
                                                    {{data[indextr].calificacionExtraordinario}} <span class="text-success text-sm">liberada</span>
                                            </div><div v-else-if="data[indextr].calificacionFinal<7 && data[indextr].calificacionRegular<7" >
                                                     {{data[indextr].calificacionExtraordinario}}  <span class="text-danger text-sm">sin liberar</span>
                                                    </div>

                                        </vs-td> -->

                                        <vs-td :data="data[indextr].id">
                                            {{data[indextr].calificacion}}
                                        </vs-td>
                                        <vs-td style="text-align: center;" :data="data[indextr].id">
                                            <!-- :disabled="data[indextr].idAgno <year_act" -->
                                            <vs-button radius color="success" type="gradient" icon-pack="feather" icon="icon-edit" 
                                              @click="editar_calificacion(data[indextr].idCalificacion,data[indextr].AGidGrupo,data[indextr].AGidAlumno,data[indextr].nombre,data[indextr].matricula,indextr+1)"></vs-button>
                                        </vs-td>
                                        <vs-td style="text-align: center;" :data="data[indextr].id">
                                            <vs-button radius color="warning" type="gradient" icon-pack="feather" icon="icon-trash"  @click="baja_alumno(data[indextr].id)"></vs-button>
                                        </vs-td>
                                    </vs-tr>
                                </template>
                            </vs-table>
                        </div>
                        
                    </div>
                    <!-- formulario de calificaciones  -->
                    <vs-popup  class="holamundo"  title="Calificar" :active.sync="modalEditarCalificacion">
                        <form>
                            <!-- pendiente de revisar que muestre bien el dato del alumno a calificar  -->
                            <label class="form-label"><b> Número: {{ indextr_alu }}, Matrícula: {{matricula_alumno}},  Nombre: {{nombre_alumno_a_calificar}} </b></label>
                            
                        <vs-input name="id" type="hidden" :value="formCals.id" v-model="formCals.id"  />

                        <!-- <div class="row mb-3">
                            
                            <div class="col-5">
                                
                                <label class="form-label">Calificación 1er. Parcial </label>
                                <vs-input v-validate="'min_value:0|max_value:10|decimal:2'" type="number" :disabled="formCals.calificacionPrimerParcialActiva == false" name="cal_1er_parcial" v-model="formCals.calificacionPrimerParcial"  />
                            </div>

                            <div class="col-4">
                                <label class="form-label">Faltas del 1er. Parcial </label>
                                <vs-input v-validate="'numeric|min_value:0|decimal:0'" name="fal_1er_parcial" :disabled="formCals.calificacionPrimerParcialActiva == false" v-model="formCals.faltasPrimerParcial"  />
                            </div>
                            <div class="col-2 ml-5">
                                <label for=""></label>
                                <div class="form-group mt-3">
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" type="checkbox" :disabled="formCals.liberadaPrimerParcial == 1 || formCals.calificacionPrimerParcialActiva == false" v-model="formCals.liberadaPrimerParcial" @change="liberarPrimerParcial($event)" role="switch" id="flexSwitchCheck1erParcial">
                                        
                                         <div v-if="formCals.liberadaPrimerParcial == 1">
                                            <label class="form-check-label" for="flexSwitchCheck1erParcial">Liberada</label>
                                          </div> 
                                              <div v-else >
                                                 <label class="form-check-label" for="flexSwitchCheck1erParcial">Sin Liberar</label>
                                                 </div> 
                                    </div>
                                    </div>
                            </div>
                        </div> -->

             <!--                         
                        <span class="text-danger text-sm" v-show="errors.has('cal_1er_parcial')">{{ errors.first('cal_1er_parcial') }}</span>
                        <span class="text-danger text-sm" v-show="errors.has('fal_1er_parcial')">{{ errors.first('fal_1er_parcial') }}</span> -->

                        <!-- <div class="row mb-3">
                            <div class="col-5">
                                <label class="form-label">Calificación 2do. parcial</label>
                                <vs-input type="number" v-validate="'decimal:2|min_value:0|max_value:10'" data-vv-as="calificación" :disabled="formCals.calificacionSegundoParcialActiva == false" name="cal_2do_parcial" v-model="formCals.calificacionSegundoParcial"  id="" placeholder="" />
                            </div>  
                            <div class="col-4">
                                <label class="form-label">Faltas del 2do. Parcial </label>
                                <vs-input type="number" v-validate="'numeric|min_value:0|decimal:0'" :disabled="formCals.calificacionSegundoParcialActiva == false" name="fal_2do_parcial" v-model="formCals.faltasSegundoParcial" placeholder="" />
                            </div>
                            <div class="col-2 ml-5">
                                <label for=""></label>
                                <div class="form-group mt-3">
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" type="checkbox" :disabled="formCals.liberadaSegundoParcial == 1 || formCals.calificacionSegundoParcialActiva == false" v-model="formCals.liberadaSegundoParcial" @change="liberarSegundoParcial($event)" role="switch" id="flexSwitchCheck2doParcial">
                                          <div v-if="formCals.liberadaSegundoParcial == 1">
                                            <label class="form-check-label" for="flexSwitchCheck1erParcial">Liberada</label>
                                          </div> 
                                              <div v-else >
                                                 <label class="form-check-label" for="flexSwitchCheck1erParcial">Sin Liberar</label>
                                                 </div> 
                                    </div>
                                </div>
                                
                            </div>
                        </div> -->

                        <!-- <span class="text-danger text-sm" v-show="errors.has('cal_2do_parcial')">{{ errors.first('cal_2do_parcial') }}</span>
                        <span class="text-danger text-sm" v-show="errors.has('fal_2do_parcial')">{{ errors.first('fal_2do_parcial') }}</span> -->
                        <div class="row mb-3">
                            <label class="form-label">Calificación final</label>
                            <!-- :disabled="formCals.calificacionEstanciasActiva == false" -->
                            <vs-input type="number" v-validate="'min_value:0|max_value:10|decimal:2'"  v-model="formCals.calificacionFinal" id="" placeholder="" />
                        </div>

                        <!-- <div class="row mb-3">
                            <div class="col-5">
                                <label class="form-label">Calificación Ex. Regular</label>
                                <vs-input type="number" v-validate="'min_value:0|max_value:10|decimal:2'" :disabled="formCals.calificacionRegularActiva == false || formCals.calificacionFinal>=7"  id="" v-model="formCals.calificacionRegular" placeholder="" />
                            </div>

                            <div class="col-3">
                                <label for=""></label>
                                <div class="form-group mt-3">
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" :disabled="formCals.liberadaRegular == 1 || formCals.calificacionRegularActiva == false || formCals.calificacionFinal>=7" v-model="formCals.liberadaRegular" type="checkbox" role="switch" id="flexSwitchCheckRegular" />
                                    
                                        <div v-if="formCals.liberadaRegular == 1">
                                            <label class="form-check-label" for="flexSwitchCheck1erParcial">Liberada</label>
                                          </div> 
                                              <div v-else >
                                                 <label class="form-check-label" for="flexSwitchCheck1erParcial">Sin Liberar</label>
                                                 </div> 
                                    </div>
                                </div>
                                
                            </div>
                            
                        </div> -->

                        <!-- <div class="row mb-3">
                            <div class="col-5">
                                <label class="form-label">Calificación Ex. Extraordinario</label>
                                <vs-input type="number" v-validate="'min_value:0|max_value:10|decimal:2'" :disabled="formCals.calificacionExtraordinarioActiva == false || formCals.calificacionFinal>=7 || formCals.calificacionRegular >=7 " v-model="formCals.calificacionExtraordinario" id="" placeholder="" />
                            </div>
                            <div class="col-3">
                                <label for=""></label>
                                <div class="form-group mt-3">
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" :disabled="formCals.liberadaExtraordinario == 1 || formCals.calificacionExtraordinarioActiva == false || formCals.calificacionFinal>=7 || formCals.calificacionRegular >=7" v-model="formCals.liberadaExtraordinario" type="checkbox" role="switch" id="flexSwitchCheckExtraordinario">
                                     
                                         <div v-if="formCals.liberadaExtraordinario == 1">
                                            <label class="form-check-label" for="flexSwitchCheck1erParcial">Liberada</label>
                                          </div> 
                                              <div v-else >
                                                 <label class="form-check-label" for="flexSwitchCheck1erParcial">Sin Liberar</label>
                                                 </div> 
                                    </div>
                                </div>
                                
                            </div>
                            
                        </div> -->

                        <!-- <div class="row mb-3">
                            <label class="form-label">Calificación Definitiva</label>
                            <vs-input   disabled v-model="formCals.calificacionFinalFinal" placeholder="" />
                            
                        </div> -->

                        <div class="row mt-3">
                            
                            <vs-button type="filled" @click.prevent="save_calificacion()" class="mt-5 block">Guardar</vs-button>
                            <!-- <vs-button type="filled" @click.prevent="save_calificacion()" class="mt-5">Guardar</vs-button> -->
                            <!-- <vs-button type="filled" @click.prevent="submitForm" class="mt-5 block">Guardar</vs-button> -->
                        </div>
                        
                        </form>
                    </vs-popup>
                </vs-popup>
                <!-- Termina listado de los alumnos de un grupo -->


                
                <!-- Inicia listado de grupos -->
                <vs-popup fullscreen  class="holamundo"  title="" :active.sync="modalFormGrupo">

                    <h3>Datos del grupo: </h3>
                    <form>
                        <vs-input name="id" type="hidden" :value="form.id" v-model="form.id"  />
                        <div class="row">
                            <div class="col-1">Año</div>    
                            <div class="col-4">
                                <v-select v-validate="'required'" label="anio" name="anio" v-model="form.idAgno" :options="anios"></v-select>
                                <span class="text-danger text-sm" v-show="errors.has('anio')">{{ errors.first('anio') }}</span>

                                <!-- <vs-select label="anio" style="width: 100%" v-model="anioSelected" :options="anios"></v-select> -->
                            </div>
                            <div class="col-1">
                                Periodo
                            </div>
                            <div class="col-3">
                                <v-select label="nombre" v-model="form.idPeriodo" :options="periodosNGrupo"></v-select>
                            </div>
                            <div class="col-1">
                                Cuatrimestre
                            </div>
                            <div class="col-2">
                                <v-select label="cuatrimestre" v-model="form.idCuatrimestre" @change="getMateriasCarrera($event)" :options="cuatrimestres"></v-select>
                            </div>
                        </div>

                        <div class="row" style="margin-top:5px">
                            <div class="col-1">
                                Carrera
                            </div>
                            <div class="col-4">
                                <v-select label="nombre" v-model="form.idCarrera" @change="getMateriasCarrera($event)"  :options="carreras"></v-select>
                            </div>
                            <div class="col-1">
                                Materia
                            </div>
                            <div class="col-6">
                                <v-select label="nombre" v-model="form.idMateria" :options="materias_carrera"></v-select>
                            </div>
                        </div>
                        <div class="row" style="margin-top:5px">
                            <div class="col-1">
                                Profesor
                            </div>
                            <div class="col-4">
                                <v-select label="ncompleto" @change="getGruposProfesorNGrupo($event)"  v-model="form.idProfesor" :options="profesores_carrera"></v-select>
                            </div>
                            <div class="col-1">
                                Grupo
                            </div>
                            <div class="col-3">
                                <v-select label="digito" v-model="form.idDigito" :options="digitos"></v-select>
                            </div>
                            <div class="col-1">
                                Cupo
                            </div>
                            <div class="col-2">
                                <vs-input type="number" class="" style="width: 100%" placeholder="" v-model="form.cupo" />
                            </div>
                        </div>
                        
                        <div class="row" style="margin-top:10px">
                            <div class="col-12">
                                
                                 <p><b>Grupos creados con anterioridad para el profesor elegido con el cuatrimestre, periodo y año seleccionados</b></p>
                                <vs-table stripe :data="gruposProfesorNGrupo">

                                   <template slot="thead">
                                      
                                            <vs-th>Materia</vs-th>
                                            <vs-th>Grupo</vs-th>
                                            <vs-th>Profesor</vs-th>
                                            <vs-th>Horario</vs-th>
                                            <vs-th>No. Alumnos</vs-th>
                                        
                                   </template>

                                   <template slot-scope="{data}">
                                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                            <vs-td :data="data[indextr].id">
                                                {{data[indextr].materia}}
                                            </vs-td>
                                            <vs-td :data="data[indextr].id">
                                                {{data[indextr].digito}}
                                            </vs-td>
                                            <vs-td :data="data[indextr].id">
                                                {{data[indextr].ncompleto}}
                                            </vs-td>
                                            <vs-td :data="data[indextr].id">
                                                {{data[indextr].horario}}
                                            </vs-td>
                                            <vs-td :data="data[indextr].id">
                                                {{data[indextr].cupo}}
                                            </vs-td>
                                        </vs-tr>
                                    </template>
                                </vs-table>
                            </div>
                        </div>
                    <!-- <p v-if="mostrar_cuatrimestre"> -->
                        <!-- <v-select label="cuatrimestre" v-model="ngrupo_cuatrimestre" :options="cuatrimestres"></v-select> -->
                    <!-- </p> -->
                        <div class="row" style="margin-top:10px">
                            <div class="col-4"></div>
                            <div class="col-4" style="text-align:center">
                                <vs-button type="filled" @click.prevent="save_grupo()" class="mt-5 ">Guardar</vs-button>

                            </div>
                            <div class="col-4"></div>
                        </div>
                        </form>
                </vs-popup>
            <!-- termina listado de grupos -->       
                       
            <!-- <div class="row mt-5">
                 <div style="text-align: right;">
                    <p><vs-button class="" style="margin: 3px;"  @click="agregar_grupo()">Nuevo Grupo</vs-button> </p>
                    
                    </div>
            </div> -->
            <!-- datos materia qui{{grupos[0].materia}} -->
            <div class="row mt-5">

                

                    <vs-table search  pagination :maxItems="30" stripe :data="grupos">

                        <template slot="thead">
                            <vs-th>Clave(ID)</vs-th>
                            <vs-th>Año</vs-th>
                            <vs-th>Periodo</vs-th>
                            <vs-th>Carrera</vs-th>
                            <vs-th>Materia</vs-th>
                            <vs-th>Cuatrimestre</vs-th>
                            <vs-th>Grupo</vs-th>

                            <vs-th>Cupo</vs-th>
                           <vs-th>TotalAlumnosEnGrupo</vs-th>
                            <vs-th>Horario</vs-th>
                            <vs-th>Profesor</vs-th>
                            <vs-th>Alumnos</vs-th>
                            <vs-th>Editar</vs-th>
                            <vs-th>DescargarActa</vs-th>
                            <!-- <vs-th>Borrar</vs-th> -->
                        </template>
   <!-- <div v-show="data['materia']=='Estancia I'" > -->
                        <template slot-scope="{data}">
                          

                                  <!-- apertura para solo mostrare las materias de estancias y estadias -->
                            <vs-tr  :key="indextr" v-for="(tr, indextr) in data">                       
           
                                <vs-td :data="data[indextr].id">
                                    {{data[indextr].id}}
                                </vs-td>
                                <vs-td :data="data[indextr].id">
                                    {{data[indextr].anio}}
                                </vs-td>
                                <vs-td :data="data[indextr].id">
                                    {{data[indextr].periodo}}
                                </vs-td>
                                <vs-td :data="data[indextr].id">
                                    {{data[indextr].carrera}}
                                </vs-td>
                                <vs-td :data="data[indextr].id">
                                    {{data[indextr].materia}}
                                </vs-td>
                                <vs-td :data="data[indextr].id">

                                    {{data[indextr].idCuatrimestre}}
                                </vs-td>
                                <vs-td :data="data[indextr].id">
                                    {{data[indextr].digito}}
                                </vs-td>
                                <vs-td :data="data[indextr].id">
                                    {{data[indextr].cupo}}
                                </vs-td>
                                <vs-td :data="data[indextr].id">
                                    {{data[indextr].totalAlumnosEnGrupo}}
                                </vs-td>
                                <vs-td :data="data[indextr].id">
                                    <!-- {{data[indextr].nhorario}} -->
                                </vs-td>
                                <vs-td :data="data[indextr].id">
                                    {{data[indextr].ncompleto}}
                                </vs-td>
                                
                                <vs-td style="text-align: center;" :data="data[indextr].id"  >
                                <!--   :disabled="data[indextr].materia =='Estancia I' || data[indextr].materia =='Estancia II' || data[indextr].materia =='Estadía' 
                                         || data[indextr].digito =='CO' " 
                                    <vs-button radius color="success" type="gradient" icon-pack="feather" icon="icon-edit" @click="nuevogruposigiente(data[indextr])"></vs-button>
                                    -->
                                        <vs-button radius color="success" type="gradient" icon-pack="feather" icon="icon-users" 
                                         @click="abrirModalAlumnosDeGrupo(data[indextr].id)">
                                        </vs-button>

                                </vs-td>
                                <vs-td style="text-align: center;" :data="data[indextr].id">
                                        <vs-button radius color="success" type="gradient" icon-pack="feather" icon="icon-edit"  @click="editar_grupo(data[indextr].id)"></vs-button>
                                </vs-td>
                                   <vs-td style="text-align: center;" :data="data[indextr].id">
                                        <vs-button radius color="success" type="gradient" icon-pack="feather" icon="icon-download"  @click="genera_acta(data[indextr].id)"></vs-button>
                              
                                </vs-td>
                                
                                <!-- <vs-td style="text-align: center;" :data="data[indextr].id">
                                        <vs-button radius color="danger" type="gradient" icon-pack="feather" icon="icon-trash"  @click="openConfirm(data[indextr].id)"></vs-button>
                                </vs-td> -->
               
                             

                           </vs-tr>
                       
                   
                        
                    </template>
                    <!-- </div> -->
                     <!-- div de cierre para el if -->
                   
                          
                </vs-table>
                
                       
            </div>

                               
        </vx-card>

</template>

<style scoped>

</style>

<script>
    import vSelect from 'vue-select'
    import {FormWizard, TabContent} from 'vue-form-wizard'
    import 'vue-form-wizard/dist/vue-form-wizard.min.css'


    import Table from "../ui-elements/table/Table";

    import DragItDude from "vue-drag-it-dude";
    import Button from "../components/vuesax/button/Button";
// import func from 'vue-editor-bridge';

    export default {
        data() {
            return {
                id_rol: this.getKey('id_rol'), 
                year_act: new Date().getFullYear(),
                form:{},
                anio:'',
                periodo:'',
                carrera: localStorage.getItem('id_carrera'),
                cuatrimestre_siguiente: [{ nombre: "", idAgno: "" }],
            //   horario: [{ idDia: "1", idHora: "1" }],
                horario: [],
                periodos:[],
                anioList:{},
                anioSelected:'',
                periodosNGrupo:[],
                ngrupo_anio:{},
                anios:[],
                periodoList:{},
                periodosList:[],
                carrera_selected:'',
                text: "Just move me!",
                alumno_detalle: [],
                grupos: [],
                materias_a_duplicar: [],
                modalFormGrupo: false,
                matriculaGrupo:'',
                modalEditarCalificacion:false,
                idGrupoModal:'',
                formCals:{},
                nombre_alumno_a_calificar:false,
                matricula_alumno:false,
                indextr_alu:false,

                alumnosGrupo:[],
                modalAlumnos: false,
                
                nombre_materia_grupo_modal:'',
                nombre_profesor_grupo_modal:'',

                grupos_siguiente: [],
                carreras: [],
                digitos: [],
                cuatrimestres: [],

                carreras_select: [],
                carreraListSelected:{},
                cuatrimestreListSelected:{},
                materias_carrera_cuatrimestre_list:[],
                materiaListSelected:{},
                carreras_profesores_list:[],
                digitoListSelected:{},
                digitos_list:[],
                profesorListSelected:{},

                error_agregar_matricula:'',

                ngrupo_periodo:{},

                gruposProfesorNGrupo:[],

                nuevo_grupo_siguiente: [],
                materias_carrera: [],
                profesores_carrera: [],
                mostrar_cuatrimestre: false,
                ngrupo_carrera:{},
                ngrupo_materia : [],
                ngrupo_profesor : [],
                ngrupo_cupo : 30,
                ngrupo_cuatrimestre : '',
                ngrupo_grupo : '',

            }
        },
        components: {
            Button,
            Table,
            'v-select': vSelect,
            FormWizard,
            TabContent,
            DragItDude
        },
        created() {

if(this.id_rol == 1 || this.id_rol == 5){
            this.$vs.loading();
            this.getCuatrimestres();
            this.getCarreras();
            this.getAnios();
             this.getMateriasCarreraList();
            this.getPeriodosList();
            this.getDigitosList();
            this.getProfesores();
            this.getDigitos();
            this.error_agregar_matricula='';
 }

            
        },
        mounted(){
        },
        watch: {
            // ngrupo_materia: function(){
            //     console.log(this.ngrupo_materia.id)
            //     if(this.ngrupo_materia.id == 217){
            //         this.mostrar_cuatrimestre = true
            //     }
            //     this.getDigitos();
            // },
        },
        
        methods: {

            liberarPrimerParcial(e){
                if (e.target.checked) {
                alert('isSelected');
                }
            },

            liberarSegundoParcial(e){
                if (e.target.checked) {
                alert(e.target.id);
                }
            },

            liberarRegular(e){
                if (e.target.checked) {
                alert('isSelected');
                }
            },

            liberarExtraordinario(e){
                if (e.target.checked) {
                alert('isSelected');
                }
            },

            save_calificacion(){
                // alert('hi');
                //   console.log(this.formCals);
                this.$validator.validateAll().then(result => {
                    // alert(result);
                    // console.log(this.result);
                 if(result) {
                    // alert('hi');
                    let tokenStorage=localStorage.getItem('app-token');
                        this.$http.post("grupos/guardar_calificacion_estanciasyestadias",{token:tokenStorage,data:this.formCals}).then(
                            response => {
                                if(response.data.resultado==="ok"){ 
                                    this.$vs.notify({ color: 'success', title: 'Registro guardado', text: 'Se guardo el registro correctamente' });
                                    this.formCals={};
                                    this.modalEditarCalificacion=false;
                                    this.get_alumnos_grupo(this.idGrupoModal);

                                }else{
                                    this.$vs.notify({
                                        time: 2500,
                                        title: 'Error',
                                        text: response.data.resultado,
                                        iconPack: 'feather',
                                        icon: 'icon-alert-circle',
                                        color: 'danger'
                                    });
                                }
                                
                            },
                            error => {
                                if(error.response.data.hasOwnProperty('error') && error.response.data.error==="Token no válido" ){
                                this.$router.push({name:'pageLogin'});
                                localStorage.clear();
                                location.reload()
                                }
                                this.StepError(error);
                            }
                        );
                    }else{
                        // form have errors
                          alert('Nose puede Guardar la calificacion!!');
                    }
                });
            },

            save_grupo() {
                this.$validator.validateAll().then(result => {
                    if(result) {
                        
                       let tokenStorage=localStorage.getItem('app-token');

                        this.$http.post("grupos/agregar_grupo",{token:tokenStorage,data:this.form}).then(
                            response => {
                                if(response.data.resultado==="ok"){ 
                                    this.$vs.notify({ color: 'success', title: 'Registro guardado', text: 'Se guardo el registro correctamente' });
                                    this.form={};
                                    this.modalFormGrupo=false;
                                    this.getGrupos();

                                }else{
                                    this.$vs.notify({
                                        time: 2500,
                                        title: 'Error',
                                        text: response.data.resultado,
                                        iconPack: 'feather',
                                        icon: 'icon-alert-circle',
                                        color: 'danger'
                                    });
                                }
                                
                            },
                            error => {
                                if(error.response.data.hasOwnProperty('error') && error.response.data.error==="Token no válido" ){
                                this.$router.push({name:'pageLogin'});
                                localStorage.clear();
                                location.reload()
                                }
                                this.StepError(error);
                            }
                        );
                    }else{
                        // form have errors
                    }
                });
            },
            
            onChangeCarreraList:function(){
                
                if(this.carreraListSelected !== ""){
                    this.getGrupos();
                }
                else{
                    this.carreraListSelected={}
                    this.getGrupos();
                }
                // this.getMateriasCarreraList();
                // this.getCarrerasProfesorList();
                // this.getProfesoresCarrera();

            },



            onChangePeriodoList:function () {
                if(this.periodoList !== ""){
                    this.getGrupos();
                }else{
                    this.getGrupos();
                    this.periodoList={};
                }
                this.carreraListSelected={};
            },

            // onChangeCuatrimestreList:function(){
            //     this.getMateriasCarreraList();
            // },

            onChangeMateriasList : function() {
                this.getGrupos();
            },

            onChangeDigitosList:function(){
                this.getGrupos();
            },

            onChangeAnioList:function() {
                this.getGrupos();
            },

            onChangeProfesoresList:function(){
                this.getGrupos();
            },


            agregar_alumno_grupo:function() {
                let tokenStorage=localStorage.getItem('app-token');
                if (window.confirm("¿Seguro que desea agregar la matricula al grupo?.")) {
                    this.$http.post("grupos/agregar_matricula_grupo",{token:tokenStorage,matricula:this.matriculaGrupo,idGrupo:this.idGrupoModal}).then(
                    
                        response => {
                            this.error_agregar_matricula
                            if(response.data.status !== ""){
                                this.error_agregar_matricula=response.data.status;    
                            }else{
                                this.matriculaGrupo=''
                                this.error_agregar_matricula='';
                                this.get_alumnos_grupo(this.idGrupoModal);
                            }
                            
                        },
                        error => {
                            if(error.response.data.hasOwnProperty('error') && error.response.data.error==="Token no válido" ){
                            this.$router.push({name:'pageLogin'});
                            localStorage.clear();
                            location.reload()
                            }
                            this.StepError(error);
                        }
                    );
                }
                
            },
            
            getGruposProfesorNGrupo:function(){
                // if(this.form.idAgno.anio && this.form.idPeriodo.id && this.form.idProfesor.id){
                    if(this.form.idAgno && this.form.idPeriodo && this.form.idProfesor){
                    this.$vs.loading();
                    this.$http.get("get_grupos_profesor"+"/"+this.form.idAgno.anio+"/"+this.form.idPeriodo.id+"/"+this.form.idProfesor.id).then(
                        response => {
                            this.gruposProfesorNGrupo=response.data.grupos;
                            this.$vs.loading.close();
                        },
                        error => {
                            this.StepError(error);
                        }
                    );
                }
                    
            },
            getPeriodosList(){
                // alert("")
                // console.log(this.anioList.anio);
                    this.periodoList={};
                    this.$http.get("get_periodos").then(
                        response => {
                            this.periodosList = response.data.periodos;
                            this.periodosNGrupo = response.data.periodos;
                            this.$vs.loading.close();
                        },
                        error => {
                            this.StepError(error);
                        }
                    );
                },
                

            getAnios(){
                    this.$http.get("get_anios").then(
                        response => {
                            this.anios = response.data.anios;
                            this.$vs.loading.close();
                            // console.log(this.periodos);
                        },
                        error => {
                            this.StepError(error);
                        }
                    );
            },

            getDigitosList(){
                this.$http.get("get_digitos").then(
                    response => {
                        this.digitos_list = response.data.digitos;
                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },
            getCarreras() {
                this.$http.get("carreras").then(
                    response => {
                        this.carreras = response.data.carreras;
                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },

            getCuatrimestres(){
                this.$http.get("cuatrimestres").then(
                    response => {
                        this.cuatrimestres = response.data.cuatrimestres;
                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },
            getDigitos(){
                this.$http.get("materias_digitos").then(
                    response => {
                        // console.log(response.data)
                        this.digitos = response.data.digitos;
                        // console.log(this.digitos);
                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },
            getMateriasCarrera(){
                this.materias_carrera=[];
                this.ngrupo_materia={};
                //nada mas avia que verificar si traen variables con el if y pasar a dejarlas en el get para traer el resultado de las materias pro cuatri y carrera
                if(this.form.idCarrera && this.form.idCuatrimestre)
                this.$http.get("materias_carrera_cuatrimestre/" + this.form.idCarrera.id+"/"+this.form.idCuatrimestre.id).then(
                    response => {
                        this.materias_carrera = response.data.materias;
                    },
                    error => {
                        this.StepError(error);
                    }
                );         

                    
            },
            getMateriasCarreraList(){
                 this.getGrupos();

                this.materias_carrera_cuatrimestre_list=[];
                 //nuevo get para solo trae materias estancias y estadias
                // if(this.carreraListSelected.id && this.cuatrimestreListSelected.id)
                this.$http.get("materias_estanciasyestadias").then(
                    response => {
                        this.materias_carrera_cuatrimestre_list = response.data.materias;
                    },
                    error => {
                        this.StepError(error);
                    }
                );
                
            },

          getCarrerasProfesorList(){
                if(this.carreraListSelected.id)
                this.$http.get("profesores_carrera/" + this.carreraListSelected.id).then(
                    response => {
                        this.carreras_profesores_list = response.data.profesores;
                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },


            getProfesores(){
                this.$http.get("catalogos/get_profesores").then(
                    response => {
                        this.profesores_carrera = response.data.profesores;
                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },

            getProfesoresCarrera(){
                
                if(this.form.idCarrera)
                this.$http.get("profesores_carrera/" + this.form.idCarrera.id).then(
                    response => {
                        // console.log(response.data)
                        this.profesores_carrera = response.data.profesores;
                        //console.log(this.kardex);
                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },
            agregar_grupo(){
                this.form={};
                 this.gruposProfesorNGrupo={};
                
                this.modalFormGrupo=true
            },

            editar_grupo(id){
                this.$vs.loading();
                this.$http.get("grupos/get_grupo/"+id).then(
                    response => {     
                        this.form = response.data.grupo;
                        // console.log(this.form.idProfesor);
                        // this.form.idAgno.anio=this.form.idAgno;
                        this.modalFormGrupo=true;
                        this.$vs.loading.close();
                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },
            editar_calificacion(idCalificacion,AGidGrupo,AGidAlumno,nombre,matricula,indextr){
                this.formCals={};
                
                
                this.$http.get("grupos/get_calificacion/"+idCalificacion+"/"+AGidGrupo+"/"+AGidAlumno).then(
                    response => {
                        this.formCals = response.data.calificacion;
                        // console.log(this.formCals);
                        this.modalEditarCalificacion=true;
                        this.nombre_alumno_a_calificar=nombre;
                        this.matricula_alumno=matricula;
                        this.indextr_alu=indextr;
                        //setear de nuevo el nombre alumon selecionado
                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },
            

            abrirModalAlumnosDeGrupo(idGrupo){
                this.idGrupoModal=idGrupo;
                this.modalAlumnos=true;
                this.matriculaGrupo='';
                this.error_agregar_matricula='';
                this.$vs.loading();
                this.$http.get("grupos/get_grupo/"+idGrupo).then(
                    response => {
                        this.form = response.data.grupo;
                        //console.log(this.form.idProfesor);
                        this.nombre_materia_grupo_modal=this.form.idMateria.nombre+' '+this.form.idDigito.digito ;
                        this.nombre_profesor_grupo_modal='Profesor(a): '+this.form.idProfesor.ncompleto;
                        
                    },
                    error => {
                        this.StepError(error);
                    }
                );
                this.get_alumnos_grupo(idGrupo);
                this.$vs.loading.close();
            },

            get_alumnos_grupo:function(idGrupo){
                let tokenStorage=localStorage.getItem('app-token');
                this.$http.post("get_alumnos_grupo",{token:tokenStorage,idGrupo:idGrupo}).then(
                        
                        response => {
                            // console.log(response.data)
                            this.alumnosGrupo = response.data.alumnos;
                            //console.log(this.kardex);
                            this.$vs.loading.close();
                        },
                        error => {
                            if(error.response.data.hasOwnProperty('error') && error.response.data.error==="Token no válido" ){
                            this.$router.push({name:'pageLogin'});
                            localStorage.clear();
                            location.reload()
                            }
                            this.StepError(error);
                        }
                    );
            },

            baja_alumno:function(idAlumnoGrupo){
                let tokenStorage=localStorage.getItem('app-token');
                if (window.confirm("Confirma que desea dar de BAJA la matrícula del grupo?.")) {
                    this.$http.post("grupos/baja_alumno_grupo",{token:tokenStorage,idAlumnoGrupo:idAlumnoGrupo}).then(
                        response => {
                            this.get_alumnos_grupo(this.idGrupoModal);
                            this.$vs.notify({
                                color: 'danger',
                                title: 'Alumno dado de baja',
                                text: ''
                            });  
                        },
                        error => {
                            if(error.response.data.hasOwnProperty('error') && error.response.data.error==="Token no válido" ){
                            this.$router.push({name:'pageLogin'});
                            localStorage.clear();
                            location.reload()
                            }
                            this.StepError(error);
                        }
                    );
                }
                
            },

            openConfirm(idGrupo) {
                localStorage.setItem("grupo_a_quitar", idGrupo) // la matriculas es la variable del id del grupo em custion a elimnar borrad logico 
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: `Confirmar`,
                    text: '¿Seguro que desea quitar el grupo?.',
                    accept: this.acceptAlert
                })
            },
            acceptAlert() {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Grupo quitado',
                    text: ''
                })
                this.$http.get("quitar_grupo_siguiente/" +  localStorage.getItem("grupo_a_quitar")).then(
                    response => {
                        this.getGrupos()
                    },
                    error => {
                        this.StepError(error);
                    }
                );

            },
            getGrupos() {
                var currentTime = new Date();
                var year = currentTime.getFullYear()
                var month = currentTime.getMonth() + 1
                var periodo= parseInt(month/4)+1;
                if(this.anioList.anio){
                    this.$vs.loading();
                    this.$http.get("get_grupos_estanciasyestadias/" + this.anioList.anio + "/" + (this.periodoList && this.periodoList.id?this.periodoList.id:0) + "/" + (this.carreraListSelected && this.carreraListSelected.id?this.carreraListSelected.id:0) + "/" + (this.cuatrimestreListSelected && this.cuatrimestreListSelected.id?this.cuatrimestreListSelected.id:0) + "/" + (this.materiaListSelected && this.materiaListSelected.id?this.materiaListSelected.id:0) + "/" + (this.digitoListSelected && this.digitoListSelected.id?this.digitoListSelected.id:0) + "/" + (this.profesorListSelected && this.profesorListSelected.id?this.profesorListSelected.id:0) ).then(
                        
                        response => {
                            // console.log(response.data)
                            this.grupos = response.data.grupos;
                            //console.log(this.kardex);
                            this.$vs.loading.close();
                        },
                        error => {
                            this.StepError(error);
                        }
                    );
                }else{

                }
                
            },
            ver_alumnos(grupo){
                localStorage.setItem('id_grupo', grupo.id_unico)
                localStorage.setItem('desc_grupo', grupo.materia + " " + grupo.cuatrimestre + " " + grupo.gpo)
                this.$router.push('/directores/detallegrupo')
            },
            genera_acta(idGrupo){
              //  console.log(this.alumnos_grupo);
                open('https://cdn.upbicentenario.edu.mx/api/final_calif_estanciasyestadias/'+idGrupo)
            }
        },
    }
</script>


